import { render, staticRenderFns } from "./dispatch-worker.vue?vue&type=template&id=22acc1f6&scoped=true&"
import script from "./dispatch-worker.vue?vue&type=script&lang=ts&"
export * from "./dispatch-worker.vue?vue&type=script&lang=ts&"
import style0 from "./dispatch-worker.vue?vue&type=style&index=0&id=22acc1f6&prod&lang=scss&scoped=true&"
import style1 from "./dispatch-worker.vue?vue&type=style&index=1&id=22acc1f6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22acc1f6",
  null
  
)

export default component.exports